const fetch_config = {
  headers: { Pragma: 'no-cache' },
}

export async function GetRequest(url) {
  let data = await (await (fetch(url, fetch_config)
    .then(res => {
      return res.json()
    })
    .catch(err => {
      console.log('Error: ', err);
      throw new Error('Error: ', err);
    })
  ))
  return data;
}

export function PostRequest(url, post_data) {
  return new Promise((resolve, reject) => {
    try {
      fetch(url, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(post_data)
      }).then(async (resp) => {
        if (!resp.ok) {
          const errorData = await resp.json(); // Parse error response
          throw new Error(` ${errorData.message || "Bad Request"}`);
        }
        return resp.json();
      })
        .then(json => {
          resolve(json);
        }).catch(ex => reject(ex));
    } catch (ex) {
      reject(ex);
    }

  })

}

export function PostRequestFile(url, post_data) {
  return new Promise((resolve, reject) => {
    try {
      let formdata = new FormData();
      formdata.append('file', post_data);
      formdata.append("enctype", "multipart/form-data");

      fetch(url, {
        method: 'POST',
        headers: {
          Accept: 'application/json'
        },
        body: formdata
      }).then(async (resp) => {
        if (!resp.ok) throw new Error(resp);
        return resp.json();
      })
        .then(json => {
          resolve(json);
        }).catch(ex => reject(ex));
    } catch (ex) {
      reject(ex);
    }

  })


}
